import { render, staticRenderFns } from "./hyCom.vue?vue&type=template&id=b824eb2a&"
import script from "./hyCom.vue?vue&type=script&lang=js&"
export * from "./hyCom.vue?vue&type=script&lang=js&"
import style0 from "./hyCom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports